import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '@/globalStore/hooks.ts'
import { UseFormReset } from 'react-hook-form'
import { calculatorFormSchema } from '@/modules/utilities/calculator/types/types.ts'
import { calculatorActions } from '@/modules/utilities/calculator/store/calculatorSlice/calculatorSlice.ts'

const useCalculator = (reset?: UseFormReset<calculatorFormSchema>) => {
  const dispatch = useAppDispatch()
  const isModalOpen = useAppSelector((state) => state.calculator.modalOpen)

  const closeModal = useCallback(() => {
    dispatch(calculatorActions.closeModal())
    if (reset) reset()
  }, [dispatch, reset])

  const openModal = useCallback(() => {
    dispatch(calculatorActions.openModal())
  }, [dispatch])

  return {
    closeModal,
    openModal,
    isOpen: isModalOpen
  }
}

export default useCalculator
